
// src/web/components/announces-tab.jsx

import React from 'react'
import connect from '../../connects/announces-tab'
import {
  List,
} from 'react-toolbox/lib/list'
import listTheme from 'react-toolbox/lib/list/theme.css'
import classnames from 'classnames'
import wrapedListTheme from './themes/wraped-list.css'
import AnnouncesItem from './announces-item.jsx'
import moment from 'moment'

class AnnouncesPage extends React.Component {
  render() {
    const {
      t,
      ui,
      announces,
    } = this.props
  
    return (
      <List selectable className={classnames(listTheme.list, wrapedListTheme.list)}>
        {announces && announces.length > 0 && announces.map((announce) => 
          <AnnouncesItem key={announce.announce_id} isUnread={ui.currentDate <  moment(announce.start_at).format('YYYY-MM-DD HH:mm:SS')} announce={announce} />
        )}
        {(!announces || announces.length == 0) && <div style={{ display: 'flex', justifyContent: 'center'}}>
          {t('label:通知がありません')}
        </div>}
      </List>
    )
  }
}

export const RawAnnouncesPage = AnnouncesPage
export default connect(AnnouncesPage)



// WEBPACK FOOTER //
// ./src/web/components/announces-tab.jsx